import styled, { css } from 'styled-components';
import { labelStyles, themeOptions } from 'styles';

interface StyledBasicTextFieldV2Props {
  width?: string;
  direction?: 'row' | 'column';
  $noMargin?: boolean;
  $labelPosition?: 'top' | 'left';
}

export const StyledBasicTextFieldV2 = styled.div<StyledBasicTextFieldV2Props>`
  position: relative;
  display: ${({ direction }) => (direction === 'column' ? 'flex' : 'block')};
  flex-direction: ${({ direction }) => (direction === 'column' ? 'column' : 'row')};
  margin-bottom: ${({ $noMargin }) => ($noMargin ? '0px' : '20px')};

  ${({ $labelPosition }) =>
    $labelPosition === 'left' &&
    css`
      ${labelStyles}
    `}

  span {
    font-weight: 600;
    display: inline-block;
    margin-bottom: 7px;
    padding-left: 8px;

    .required {
      color: red;
      padding-left: 0;
    }
  }

  .tf-label {
    display: flex;
    align-items: center;
    position: relative;

    span {
      width: 10px;
      height: 5px;
      position: relative;
      top: -4px;
      left: 2px;
    }
  }

  .MuiOutlinedInput-root {
    padding-left: 12px;
    height: 40px;
    width: ${({ width }) => (width ? width : '100%')};
    overflow-y: hidden;

    background-color: var(--color-white);
    border: 1px solid var(--color-pale-gray);
    border-radius: 6px;

    &:hover {
      box-shadow: 0 0 0 3px var(--color-off-white);
      .MuiOutlinedInput-notchedOutline {
        border: 1px solid #dadada;
      }
    }
    &:active {
      box-shadow: none !important;
      border-color: var(--color-pale-gray);
    }

    .MuiOutlinedInput-input {
      padding: 0;
      width: 100%;
      border-radius: 6px;
      outline: none;
      appearance: none;
      background-color: var(--color-white);

      &:disabled {
        color: var(--color-medium-gray);
        background-color: var(--color-off-white);
      }
    }
  }

  .MuiOutlinedInput-root.Mui-disabled {
    background-color: var(--color-off-white);
  }
`;
